import { render, staticRenderFns } from "./BookingAlternatives.vue?vue&type=template&id=e73df13c"
import script from "./BookingAlternatives.vue?vue&type=script&lang=js"
export * from "./BookingAlternatives.vue?vue&type=script&lang=js"
import style0 from "./BookingAlternatives.vue?vue&type=style&index=0&id=e73df13c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports